import { ListBase } from 'react-admin';
import { MissionGridLayout } from './MissionGridLayout';

export const MissionGrid = () => {
    return (
        <ListBase
            resource="mission"
            perPage={100}
            filter={{ status: 'not.in.(archived,cancelled)' }}
            sort={{ field: 'updatedAt', order: 'DESC' }}
        >
            <MissionGridLayout />
        </ListBase>
    );
};
